module.exports = __webpack_public_path__ + "static/img/pic1.d105a22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slideShow/pic1.jpg
// module id = U6gL
// module chunks = 0